import { render } from "./BellRingOutline.vue?vue&type=template&id=1ecec428"
import script from "./BellRingOutline.vue?vue&type=script&lang=js"
export * from "./BellRingOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__